module.exports = __webpack_public_path__ + "fe8361a9af0984ac054889c56702f3f1.png";